import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FeedbackModal from "./pages/ThankYou/FeedbackModal";
import FormSubmitThankYou from "./pages/ThankYou/FormSubmitThankYou";
import ReferralForm from "./pages/referral-form/ReferralForm";
import VoucherForm from "./pages/voucher-form/VoucherForm";
import NotFound from "./pages/not-found/NotFound";
import VoucherThankyou from "./pages/ThankYou/VoucherThankyou";
import NewChannelPartnerForm from "./pages/new-channel-partner-form/NewChannelPartnerForm";
import BookingHandler from "./pages/booking-journey-selector/BookingHandler";
import EntityBasedPreview from "./pages/reusable-preview/EntityBasedPreview";
import KYCDocumentsPage from "./pages/new-booking-form/components/kyc-documents/KYCDocumentsPage";
import MutliUnitBookingsTable from "./pages/new-booking-form/multiunit-components/MutliUnitBookingsTable";
import ApplicantMapping from "./pages/new-booking-form/components/applicant-mapping/ApplicantMapping";
import VoucherPreview from "./pages/reusable-preview/VoucherPreview";
import VoucherApplicantMapping from "./pages/voucher-booking-mapping/VoucherApplicantMapping";
function App() {
  const theme = createTheme({
    typography: {
      fontFamily: "Poppins, sans-serif",
      h1: {
        fontFamily: "Poppins, sans-serif", // Custom font for h1
      },
      body: {
        fontFamily: "Poppins, sans-serif", // Custom font for body text
      },
    },
  });

  return (
    <div className="height100">
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Switch>
            {/* Unified booking flow */}
            <Route
              exact
              path="/booking-form/:oppId"
              component={BookingHandler}
            />

            <Route
              exact
              path="/applicant-mapping/:groupId"
              component={ApplicantMapping}
            />

            <Route
              exact
              path="/voucher-applicant-mapping/:oppId"
              component={VoucherApplicantMapping}
            />

            <Route
              exact
              path="/referral-form/:oppId"
              component={ReferralForm}
            />
            <Route
              exact
              path="/voucher-form/:voucherId"
              component={VoucherForm}
            />
            <Route
              exact
              path="/voucher-preview/:voucherId"
              component={VoucherPreview}
            />
            <Route exact path="/404" component={NotFound} />
            <Route
              exact
              path="/customer-preview/:oppId"
              component={EntityBasedPreview}
            />
            <Route exact path="/feedback/:oppId" component={FeedbackModal} />
            <Route
              exact
              path="/thank-you/:oppId"
              component={FormSubmitThankYou}
            />
            <Route
              exact
              path="/voucher-form/thank-you/:voucherId"
              component={VoucherThankyou}
            />
            <Route
              exact
              path="/channel-partner-link/:channelpartnerId"
              component={NewChannelPartnerForm}
            />
            <Route
              exact
              path="/kyc-documents/:oppId"
              component={KYCDocumentsPage}
            />
            <Route
              exact
              path="/group-listing/:groupId"
              component={MutliUnitBookingsTable}
            />
            <Route path="*" component={NotFound} />
          </Switch>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
